import { CLASS_BOUNDS, mapEmpty, mapRamp } from "../lib/constants";

const labelFor = (i) => (i === CLASS_BOUNDS.length - 1 ? `${CLASS_BOUNDS[i].toLocaleString("en-US")}+` : `${CLASS_BOUNDS[i]}–${CLASS_BOUNDS[i + 1] - 1}`);

const Swatch = ({ color, bordered = false }) => (
  <span className={`w-3 h-3 tv:w-[17px] tv:h-[17px] rounded-[3px] shrink-0 ${bordered ? "border border-slate-300" : ""}`} style={{ background: color }} />
);

export const MapLegend = ({ dark = false }) => (
  <div data-testid="map-legend" className="flex flex-wrap items-center gap-x-2.5 gap-y-1 tv:gap-[15px] text-[10px] sm:text-[11px] tv:text-[14px] text-slate-600 max-w-[calc(100vw-3rem)] tv:max-w-none">
    {mapRamp(dark).map((color, i) => (
      <div key={color} className="flex items-center gap-1 tv:gap-1.5 whitespace-nowrap">
        <Swatch color={color} />
        <span className="num">{labelFor(i)}</span>
      </div>
    ))}
    <div className="flex items-center gap-1 tv:gap-1.5 whitespace-nowrap" data-testid="legend-no-clients">
      <Swatch color={mapEmpty(dark)} bordered />
      <span>no venues</span>
    </div>
  </div>
);
